<template lang="html">
  <section id="reviews" class="flex scroll-mt-20 flex-col gap-6 px-4 pb-10 sm:px-0">
    <h2 class="text-xl font-bold">
      Отзывы
    </h2>
    <ReviewsSummary :summary="props.summary" @write="write" />
    <ReviewsFeed ref="feed" :product-id="props.productId" :initial-page="props.initialPage" />
  </section>
</template>

<script setup lang="ts">
import type { PageOfShowcaseReviewDto, ShowcaseReviewSummaryDto } from '@repo/api/web/models'

import ReviewsFeed from './ReviewsFeed.vue'
import ReviewsSummary from './ReviewsSummary.vue'
import { useReviewFormModal } from '../composables/useReviewFormModal'

/**
 * Контейнер блока отзывов на странице товара: сводка рейтинга, кнопка «Оставить отзыв» и лента.
 * Лента привязана к товару при создании — родитель пересоздаёт блок через `:key="productId"`.
 */
const props = defineProps<{
  productId: number
  summary: ShowcaseReviewSummaryDto
  /** Первая страница ленты, уже загруженная страницей товара (см. `ReviewsFeed`) */
  initialPage?: PageOfShowcaseReviewDto | null
}>()
/** Отзыв отправлен: родителю — перезапросить сводку рейтинга */
const emit = defineEmits<{ reviewed: [] }>()

const { openCreate } = useReviewFormModal()
/** `ReviewsFeed` асинхронный (top-level await) — тип его expose задаём явно */
const feed = useTemplateRef<{ reload: () => Promise<unknown> }>('feed')

function write() {
  openCreate(props.productId, { onDone: onReviewed })
}

// При постмодерации новый отзыв сразу публичный, при премодерации лента и сводка не изменятся.
// Сбой перезагрузки ленты reload() показывает сам (тост и «Повторить»)
function onReviewed() {
  emit('reviewed')
  feed.value?.reload()
}
</script>
